import { css } from '@emotion/react';

import GradientAiIcon from '../shared/gradient-ai-icon';
import useAiSuggestComponents from './hooks/use-ai-suggest-components';

const ActivityItemHeader = (props) => {
  const { type } = props;
  const { componentTextMapping, componentIconMapping } = useAiSuggestComponents();

  const styles = css`
    &.activity-header {
      flex: 0 0 180px;
    }
  `;

  return (
    <div className='activity-header d-flex mr-4' css={styles}>
      <GradientAiIcon
        icon={componentIconMapping[type]}
        size='small'
        className='pr-2'
      />
      <span className='text-lg-bold'>{componentTextMapping[type]}</span>
    </div>
  );
};

export default ActivityItemHeader;
